import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IQuoteState } from './quote.types';
import { IQuoteData, IQuotePackageData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { Transition } from '@/models/transition';

export const state: IQuoteState = {
  version: 1,
  quotes: [] as IQuoteData[],
  quotePackages: [] as IQuotePackageData[],
  count: 0,
  quoteActivities: [] as Transition[],
  lastPromise: null
};

const namespaced = true;

export const quote: Module<IQuoteState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
